<template>

  <v-sheet
    height="100%"
    class="overflow-hidden"
    style="position: relative; margin-top:0px; border-radius:0; background-color:#e1e1e1; "
  >
   <div class="ml-0 mr-0" style="width:100%; ">
        <v-row class="align-center justify-center px-0">
            <v-col
            cols="12"
            class="justify-center align-center px-12 py-6"
            style="min-height: 84vh;"
            >
                <v-row style="justify-content: center;    margin-top: 8vh;">
                    <p style="color:#505050; font-size: 50px;    font-weight: 500;">Alfred Turnos</p>
                </v-row>
                <v-row style="justify-content: center;    margin-top: 12vh;">
                    <v-btn
                    @click="goDesktop"
                    color="#689840"
                    dark
                    rounded
                    depressed
                    large
                    outlined
                    min-width="200"
                    style="    background-color: white;    font-weight: 800;"
                    ><p style="color:#689840; padding-top: 10%;">Desktop</p></v-btn>
                </v-row>
                <v-row style="justify-content: center; margin-top: 5vh;">
                    <v-btn
                    @click="goMobile"
                    color="#689840"
                    dark
                    rounded
                    depressed
                    large
                    outlined
                    min-width="200"
                    style="    background-color: white;    font-weight: 800;"
                    ><p style="color:#689840; padding-top: 10%;">Mobile</p></v-btn>
                </v-row>
                <v-row style="justify-content: center; margin-top: 20vh;">
                  
                  <img v-bind:src="require('../assets/' + img)" />
                    
                </v-row>          
            </v-col>
        </v-row>
    </div>
  </v-sheet>
</template>

<script>
import axios from "axios";
import { mapState, mapActions, mapMutations } from "vuex";
import router from "vue-router";



export default {
  name: "Queues",
  components: {

  },
  data() {
    return {
      img: "admiralogo.png"
    };
  },
  computed: {

    ...mapState("queues", []),

  },
  methods: {
    ...mapMutations("queues", []),
    ...mapActions("queues", []),
    goDesktop(){
        this.$router.push({
            name: "Queues",
        });

    },
    goMobile(){
      this.$router.push({
          name: "QueuesMobile",
      });
    },
    
   
  },

  async created() {    

   
  },
  destroyed() {},
};
</script>

<style scoped>
a {
  text-decoration: none;
}
>>> .v-data-table__wrapper {
  height: calc(100vh - 207px);
  overflow: auto;
}
>>> th {
vertical-align: top;
}
</style>


// WEBPACK FOOTER //
// src/views/homeQueue.vue